import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { SpinnerLoader, ToggleBlock } from 'shared/ui'
import { useCallPopUpDefaultContext } from 'widgets/CallPopUp/context/callPopUpDefaultContext'
import { ContactsInfoForm } from 'widgets/ContactsInfoForm'
import { contactsDetailsGlobalStore } from 'widgets/ContactsDetails/store'
import { ContactsIntegrations } from 'widgets/ContactsDetails/ui/ContactsIntegrations'
import styles from './styles.module.scss'

export const CallInsightCardsDetails = observer(() => {
  const { callPopUpInsightCardsStore } = useCallPopUpDefaultContext()

  const { contactInfoFormStore, contactIntegrationsStore, isViewAll, callNoteStore, loading } =
    callPopUpInsightCardsStore

  useEffect(() => {
    return () => {
      callNoteStore.handleMessageSend()
    }
  }, [])

  if (loading) {
    return (
      <div className={styles.tabContent}>
        <SpinnerLoader ariaLabel={'CallInsightCardsDetails'} />
      </div>
    )
  }

  return (
    <>
      {!isViewAll && (
        <ToggleBlock
          ariaLabel='callInsightCardsDetailsSelector'
          borders={{ bottom: true, top: true }}
          title='Contact details'
          hideBottomMargin
          hideDraggingIcon
          hidePadding
          headerStyles={{ padding: '24px 16px 23px 4px' }}
          isOpen={contactsDetailsGlobalStore.isOpenBlock('callInsightContactDetails')}
          onToggle={() => contactsDetailsGlobalStore.toggleBlockView('callInsightContactDetails')}
        >
          <div className={styles.tabContent}>
            <ContactsInfoForm store={contactInfoFormStore} />
          </div>
        </ToggleBlock>
      )}
      <ContactsIntegrations
        store={contactIntegrationsStore}
        hideDraggingIcon
        headerStyles={{ padding: '22px 16px 21px 4px' }}
      />
    </>
  )
})
